import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Clapperboard, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ScriptForm } from "./ScriptForm";
import { ScriptEditor } from "./ScriptEditor";
import { AdminOnlyBanner, fmtDate } from "./shared";

const inferObiettivo = (t) => {
  const s = t.toLowerCase();
  if (/vend|offert|promo|scont|acquist|prezz/.test(s)) return "vendita";
  if (/contatt|prenot|preventiv|lead|consulenz|appuntament/.test(s)) return "lead";
  if (/sondagg|domand|comment|quiz|interaz|community/.test(s)) return "engagement";
  if (/brand|valor|storia|chi siamo|identit|dietro le quinte/.test(s)) return "brand";
  return "awareness";
};

export const ClientVideoScripts = ({ client }) => {
  const [list, setList] = useState(null);
  const [sel, setSel] = useState(null);
  const [form, setForm] = useState(false);
  const [initial, setInitial] = useState(null);
  const [sp, setSp] = useSearchParams();
  useEffect(() => {
    const aid = sp.get("analisi"), ix = Number(sp.get("idea"));
    if (!aid || Number.isNaN(ix)) return;
    api.get(`/admin-ai/competitor/${aid}`).then((r) => {
      const x = r.data.idee?.[ix];
      if (!x) return;
      const day = new Date(r.data.created_at).toLocaleDateString("it-IT");
      setInitial({ piattaforma: "Instagram Reel", obiettivo: inferObiettivo(`${x.titolo} ${x.hook} ${x.perche}`), tema: x.titolo.slice(0, 500),
        punti: `Hook: ${x.hook}\nPerché funziona: ${x.perche}`.slice(0, 2000), riferimento: `Idea dall'analisi competitor & trend del ${day} (Cliente › Competitor & trend)`.slice(0, 1000) });
      setForm(true); setSel(null);
      setSp({ tab: "script" }, { replace: true });
    }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { api.get(`/admin-ai/clients/${client.id}/script`).then((r) => { setList(r.data); const want = sp.get("script"); if (want && r.data.some((x) => x.id === want)) { setSel(want); setForm(false); } else setForm((f) => f || !r.data.length); }).catch(() => setList([])); }, [client.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const add = (s) => { setList((l) => [s, ...(l || [])]); setSel(s.id); setForm(false); };
  const upd = (s) => setList((l) => l.map((x) => (x.id === s.id ? s : x)));
  const current = (list || []).find((x) => x.id === sel);
  return (
    <div data-testid="client-video-scripts">
      <AdminOnlyBanner>Script video con AI: visibile e utilizzabile solo da te.</AdminOnlyBanner>
      <div className="grid gap-5 lg:grid-cols-[300px_1fr]">
        <aside className="space-y-2" data-testid="script-list">
          <Button onClick={() => { setForm(true); setSel(null); }} className="w-full rounded-full bg-[#E8173A] hover:bg-[#C8102E] font-bold" data-testid="script-new"><Plus className="h-4 w-4 mr-1" />Nuovo script</Button>
          {list && !list.length && <div className="text-sm text-slate-600 px-1">Nessuno script salvato.</div>}
          {(list || []).map((s) => (
            <button key={s.id} onClick={() => { setSel(s.id); setForm(false); }} data-testid={`script-item-${s.id}`}
              className={`w-full text-left rounded-xl border px-3 py-2.5 transition-colors ${sel === s.id ? "border-[#0A1128] bg-white" : "border-[#5FB3EA] bg-white/60 hover:bg-white"}`}>
              <div className="flex items-center gap-2 font-bold text-sm text-[#0A1128]"><Clapperboard className="h-4 w-4 shrink-0" /><span className="truncate">{s.titolo}</span></div>
              <div className="mt-0.5 text-[11px] text-slate-500">{s.brief?.piattaforma} · {s.brief?.durata}s · {s.stato === "approvato" ? "Approvato" : "Bozza"} · {fmtDate(s.created_at)}</div>
            </button>
          ))}
        </aside>
        <section className="min-w-0">
          {form && <ScriptForm clientId={client.id} initial={initial} onCreated={(s) => { setInitial(null); add(s); }} />}
          {!form && current && <ScriptEditor key={current.id} script={current} onChange={upd} onDuplicated={add} onDeleted={(id) => { setList((l) => l.filter((x) => x.id !== id)); setSel(null); }} />}
          {!form && !current && list?.length > 0 && <div className="text-sm text-slate-600">Seleziona uno script dall'elenco.</div>}
        </section>
      </div>
    </div>
  );
};
